export default __webpack_public_path__ + "static/dclogo-dbba50cd62ed78f4c10533d0b02fa6ca.png";